<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input
              v-model="query.signUpNo"
              placeholder="请输入订单编号"
              clearable
              size="small"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="参会人：">
            <el-input
              v-model="query.keywordsCarryPeople"
              placeholder="请输入姓名/手机号"
              clearable
              size="small"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="账号类型：">
            <el-select v-model="query.isItCarry" placeholder="请选择" clearable size="small">
              <el-option label="主报名" :value="0"></el-option>
              <el-option label="携带人员报名" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="用户手机号：">
            <el-input
              v-model="query.userMobile"
              placeholder="请输入用户手机号"
              clearable
              size="small"
            />
          </el-form-item> -->
          <el-form-item label="会议名称：">
            <el-select v-model="selectedMeetingId" placeholder="请输入会议名称搜索" remote :remote-method="searchMeetings"
              :loading="meetingSearchLoading" filterable clearable size="small" @change="handleMeetingChange">
              <el-option v-for="(item, index) in meetingSearchOptions" :key="index"
                :label="item.title + (item.startTime ? ' (' + item.startTime.substring(0, 10) + ')' : '')"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会议类型：">
            <el-select v-model="query.meetingCategoryId" placeholder="请选择" clearable size="small">
              <el-option v-for="item in meetingCategoryOptions" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签到方式：">
            <el-select v-model="query.signInMethod" placeholder="请选择" clearable size="small">
              <el-option label="后台签到" :value="20"></el-option>
              <el-option label="App签到" :value="10"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="报名类型：">
            <el-select v-model="query.source" placeholder="请选择" clearable size="small">
              <el-option label="App报名" :value="10"></el-option>
              <el-option label="后台添加" :value="20"></el-option>
              <el-option label="导入" :value="21"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名人：">
            <el-select v-model="query.registrantIdentityId" placeholder="请选择身份" clearable size="small"
              style="width: 120px; margin-right: 10px" @change="handleRegistrantIdentityChange">
              <el-option v-for="item in identityList" :key="item.id" :label="item.name" :value="item.level"></el-option>
            </el-select>
            <el-select v-model="selectedRegistrantUser" placeholder="请输入姓名/手机号" remote
              :remote-method="searchRegistrants" :loading="registrantSearchLoading" filterable clearable size="small"
              style="width: 200px" :disabled="!query.registrantIdentityId" @change="handleRegistrantChange">
              <el-option v-for="(item, index) in registrantSearchOptions" :key="index" :label="item.value"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付渠道：">
            <el-select v-model="query.paymentMethod" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="线上支付" value="online"></el-option>
              <el-option label="线下支付" value="offline"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否收费：">
            <el-select v-model="query.isFree" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="住宿信息：">
            <el-select v-model="query.isAssignStay" placeholder="请选择" clearable size="small">
              <el-option label="未分配" :value="0"></el-option>
              <el-option label="已分配" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="退款状态：">
            <el-select v-model="query.refundStatus" placeholder="请选择" clearable size="small">
              <el-option label="已退款成功" :value="30"></el-option>
              <el-option label="退款失败" :value="40"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="timeFilter" placeholder="请选择" clearable size="small">
              <el-option label="会议时间" :value="1"></el-option>
              <el-option label="报名时间" :value="2"></el-option>
              <el-option label="签到时间" :value="3"></el-option>
              <el-option label="取消时间" :value="4"></el-option>
              <el-option label="撤回时间" :value="5"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期" style="margin-left: 10px;"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right;">
        <el-button type="primary" size="mini" @click="openSyncToDXIOTDialog" v-hasPermi="['meeting:record:add']">同步报名信息</el-button>
        <el-button type="primary" size="mini" @click="handleCreate" v-hasPermi="['meeting:record:add']">后台报名</el-button>
        <el-button type="primary" size="mini" @click="handleDownload1" plain>下载名单模板</el-button>
        <el-button v-hasPermi="['meeting:record:import']" size="mini" type="primary" @click="handleImport">导入名单</el-button>
        <el-button type="primary" size="mini" @click="handleDownload2" plain>下载住宿模板</el-button>
        <el-upload v-hasPermi="['meeting:record:import1']" style="display: inline-block;margin:0 5px"
          :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFileStay" :file-list="fileList">
          <el-button size="mini" type="primary">导入住宿</el-button>
        </el-upload>
        <el-button type="primary" size="mini" @click="handleDownload" plain
          v-hasPermi="['meeting:record:export']">导出</el-button>
      </div>
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待审核" name="10"></el-tab-pane>
          <el-tab-pane label="未开始" name="99"></el-tab-pane>
          <el-tab-pane label="待参会" name="20"></el-tab-pane>
          <el-tab-pane label="已签到" name="30"></el-tab-pane>
          <el-tab-pane label="已完成" name="22"></el-tab-pane>
          <el-tab-pane label="已取消" name="40"></el-tab-pane>
          <el-tab-pane label="撤回报名" name="50"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="订单编号" prop="signUpNo" align="center" width="200" fixed key="1">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="handleShow(row, 2)">{{
              row.signUpNo
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="参会人信息" prop="describe" align="center" width="140" key="2">
          <template slot-scope="{ row }">
            <span v-if="!row.carryPeoples || !Array.isArray(row.carryPeoples) || row.carryPeoples.length === 0">-</span>
            <span v-else>
              <template v-if="row.carryPeoples[0]">
                {{ row.carryPeoples[0].realName }}{{
                  row.carryPeoples[0].relationship ? `(${row.carryPeoples[0].relationship})` : ""
                }}<br />{{ row.carryPeoples[0].mobile }}
              </template>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="账号类型" prop="describe" align="center" width="140" key="6">
          <template slot-scope="{ row }">
            {{ row.userMainId > 0 ? "子账号" : "主账号" }}
          </template>
        </el-table-column>
        <el-table-column label="会议信息" prop="describe" align="left" width="240" key="3">
          <template slot-scope="{ row }">
            <div class="meeting-info-cell" style="display: flex; align-items: center;" v-if="row.meeting">
              <el-image style="width: 36px; height: 36px; margin-right: 8px;" :src="row.meeting.imageUrl"
                :preview-src-list="[row.meeting.imageUrl]"></el-image>
              <div>
                <div class="meeting-title">{{ row.meeting.title }}</div>
                <div class="meeting-category" style="font-size: 12px; color: #999;">
                  会议类型：{{ row.meeting.categoryName }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报名类型" prop="describe" align="center" width="140" key="4">
          <template slot-scope="{ row }">
            {{ row.isItCarry ? "被报名" : "主报名" }}
          </template>
        </el-table-column>
        <el-table-column label="下单人" prop="describe" align="center" width="140" key="5">
          <template slot-scope="{ row }">
            <template v-if="!row.isItCarry">
              {{ row.userRealName }}({{ row.userLevelName }}){{
                row.userDeleted ? "(删除)" : ""
              }}<br />{{ row.userMobile }}
            </template>
            <template v-else>
              {{ row.carryUserRealName }}({{ row.carryUserLevelName }}){{
                row.userDeleted ? "(删除)" : ""
              }}<br />{{ row.carryUserMobile }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="报名人数" prop="handleCarryPeople" align="center" key="7">
          <template slot-scope="{ row }">
            {{
              row.carryPeopleNum + row.carryChildNum
            }}
            <!-- <el-link type="primary" @click="handleCarryPeople(row)">{{
              row.carryPeopleNum
            }}</el-link> -->
          </template>
        </el-table-column>
        <el-table-column label="报名方式" align="center" key="8">
          <template slot-scope="{ row }">
            {{
              row.source === 10
                ? "App报名"
                : row.source === 20
                  ? "后台添加"
                  : row.source === 21
                    ? "导入"
                    : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="报名费用" align="center" key="9">
          <template slot-scope="{ row }">
            {{ row.isItCarry?"-":(row.paymentMethod === 30 ? formatFee(row.payVouchersFee) : formatFee(row.fee)) }}
          </template>
        </el-table-column>
        <el-table-column label="支付渠道" prop="paymentMethod" align="center" key="23">
          <template slot-scope="{ row }">
            {{
              row.isItCarry?"-":(row.paymentMethod === 30 ? "线下支付" : "线上支付")
            }}
          </template>
        </el-table-column>
        <el-table-column label="支付方式" prop="paymentMethod" align="center" key="10">
          <template slot-scope="{ row }">
            {{
              signUpFeePayMethod(row)
            }}
          </template>
        </el-table-column>
        <el-table-column label="会议时间" prop="startTime" sortable="custom" align="center" width="180"
          v-if="activeName === '99' || activeName === '20'" key="11">
          <template slot-scope="{ row }">
            {{ row.meeting.startTime }} ~ {{ row.meeting.endTime }}
          </template>
        </el-table-column>
        <el-table-column label="住宿信息" align="center" v-if="activeName === '99' || activeName === '20'" key="12">
          <template slot-scope="{ row }">
            {{ row.isAssignStay ? "已分配" : "未分配" }}
          </template>
        </el-table-column>
        <el-table-column label="提交报名时间" prop="createdTime" sortable="custom" align="center" width="200"
          v-if="activeName === '99' || activeName === '20' || activeName === '10'" key="13" />
        <el-table-column label="签到方式" align="center" v-if="activeName === '30' || activeName === '22'" key="14">
          <template slot-scope="{ row }">
            {{
              row.signInMethod === 10
                ? "App签到"
                : row.signInMethod === 20
                  ? "后台签到"
                  : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="签到时间" prop="signInTime" sortable="custom" align="center" width="200"
          v-if="activeName === '30'" key="15" />
        <el-table-column label="完成时间" prop="meetingEndTime" sortable="custom" align="center" width="200"
          v-if="activeName === '22'" key="16">
          <template slot-scope="{ row }">
            {{ row.meeting && row.meeting.endTime ? row.meeting.endTime : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="取消时间" prop="cancelTime" sortable="custom" align="center" width="200"
          v-if="activeName === '40'" key="17" />
        <el-table-column label="取消类型" prop="cancelType" align="center" 
        width="200" 
        v-if="activeName === '40'">
          <template slot-scope="{ row }">
            {{
              row.cancelType === 20
                ? "报名订单取消"
                : row.cancelType === 30
                  ? "会议取消"
                  : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="取消原因" prop="cancelReason" align="center" v-if="activeName === '40'" />
        <el-table-column label="撤回时间" prop="revokeTime" align="center" v-if="activeName === '50'" />
        <el-table-column label="退款金额" prop="fee" align="center" v-if="activeName === '40' || activeName === '50'" />
        <el-table-column label="备注" prop="message" align="center" />
        <el-table-column label="设备签到" align="center">
          <template slot-scope="{ row }">
            <div class="sync-status-text sync-status-click" @click="openSignInDialog(row)">
              <div v-if="row.signInSyncStatus == 10">部分允许</div>
              <div v-if="row.signInSyncStatus == 30">不允许签到</div>
              <div v-else>允许签到</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否信息同步" prop="message" align="center" min-width="120">
          <template slot-scope="{ row }">
            <div class="sync-status-text sync-status-click" @click="openInfoSyncDialog(row)">
              <div v-if="row.infoSyncStatus == 10">部分同步</div>
              <div v-if="row.infoSyncStatus == 30">同步成功</div>
              <div v-else>未同步</div>
            </div>
          </template></el-table-column>

        <el-table-column label="操作" align="center" fixed="right" width="200" v-if="activeName !== '10'">
          <template slot-scope="{ row }">
            <template v-if="activeName === '99' || activeName === '20'">
              <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['meeting:record:modify']">住宿信息</el-button>
              <el-button type="text" @click="handleCancel(row)" v-hasPermi="['meeting:record:cancel']">取消报名
              </el-button>
              <el-button type="text" @click="handleTransportation(row)"
                v-hasPermi="['meeting:record:modify']">交通方式</el-button>
              <el-dropdown @command="handleMoreCommand">
                <el-button type="text">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'log', row: row }">日志记录</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'transfer', row: row }">转票</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <el-button type="text" v-if="activeName === '20'" @click="handleSignin(row)"
              v-hasPermi="['meeting:record:sign']">签到
            </el-button>
            <!-- <el-button
                type="text"
                @click="handleCancel(row)"
                v-if="activeName === '99' || activeName === '20' || activeName === '10'"
                v-hasPermi="['meeting:record:cancel']"
                >取消报名
                </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <record-add ref="recordAdd" @created="doQueryList({})" />
    <opera-vue ref="operaVue" @created="doQueryList({})" />
    <accommodation-vue ref="accommodationVue" @created="doQueryList({})" />
    <carry-people-vue ref="carryPeopleVue" />
    <transportation-vue ref="transportationVue" @created="doQueryList({})" />
    <transfer-ticket-vue ref="transferTicketVue" @created="doQueryList({})" />

    <!-- 设备签到弹窗 -->
    <el-dialog title="设备是否允许签到" :visible.sync="signInDialogVisible" width="700px">
      <el-table :data="carryPeopleList" border size="small">
        <el-table-column label="姓名" prop="realName" align="center" min-width="100" />
        <el-table-column label="性别" align="center" width="80">
          <template slot-scope="{ row }">{{ row.sex === 1 ? "男" : row.sex === 2 ? "女" : "-" }}</template>
        </el-table-column>
        <el-table-column label="身份证号码" align="center" min-width="180">
          <template slot-scope="{ row }">{{ row.idCardNo || "-" }}{{ row.isChild ? " (儿童)" : " (成人)" }}</template>
        </el-table-column>
        <el-table-column label="设备签到" align="center" width="120">
          <template slot-scope="{ row }">{{ row.isSyncSignDxiot ? "允许签到" : "不允许签到" }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="signInDialogVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 信息同步弹窗 -->
    <el-dialog title="信息同步情况" :visible.sync="infoSyncDialogVisible" width="700px">
      <el-table :data="carryPeopleList" border size="small">
        <el-table-column label="姓名" prop="realName" align="center" min-width="100" />
        <el-table-column label="性别" align="center" width="80">
          <template slot-scope="{ row }">{{ row.sex === 1 ? "男" : row.sex === 2 ? "女" : "-" }}</template>
        </el-table-column>
        <el-table-column label="身份证号码" align="center" min-width="180">
          <template slot-scope="{ row }">{{ row.idCardNo || "-" }}{{ row.isChild ? " (儿童)" : " (成人)" }}</template>
        </el-table-column>
        <el-table-column label="是否信息同步" align="center" width="120">
          <template slot-scope="{ row }">{{ row.isSyncInfoDxiot ? "已同步" : "未同步" }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoSyncDialogVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 同步报名信息至DXIOT弹窗 -->
    <el-dialog title="同步报名信息" :visible.sync="syncToDXIOTDialogVisible" width="500px" @open="loadSyncToDXIOTMeetingOptions">
      <el-form label-width="100px">
        <el-form-item label="选择会议：" required>
          <el-select
            v-model="syncToDXIOTMeetingId"
            placeholder="请选择会议"
            filterable
            clearable
            size="small"
            style="width: 100%"
          >
            <el-option
              v-for="item in syncToDXIOTMeetingOptions"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="syncToDXIOTDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="syncToDXIOTLoading" @click="confirmSyncToDXIOT">确定</el-button>
      </div>
    </el-dialog>

    <!-- 取消报名弹窗 -->
    <el-dialog title="提示" :visible.sync="cancelRegistrationVisible" :close-on-click-modal="false" width="500px">
      <div style="display: flex; align-items: flex-start">
        <div style="
            width: 24px;
            height: 24px;
            flex-shrink: 0;
          ">
          <i class="el-icon-warning" style="color: #FAB240; font-size: 16px"></i>
        </div>
        <div style="flex: 1">
          <div style="margin-bottom: 20px">
            {{
              currentCancelRow && !currentCancelRow.isItCarry
                ? "当前取消的是主订单，所有参会人都将会被取消，是否确认取消。"
                : "是否确认取消会议报名"
            }}
          </div>
          <el-form ref="cancelForm" :model="cancelForm" :rules="cancelFormRules" label-width="100px">
            <el-form-item label="取消原因：" prop="cancelReason" required>
              <el-select v-model="cancelForm.cancelReason" placeholder="请选择取消原因" style="width: 100%">
                <el-option v-for="(item, index) in cancelReasonOptions" :key="index" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRegistrationVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmCancel">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import recordAdd from "./add";
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
import Pagination from "@/components/Pagination";
import operaVue from "../meetingList/opea.vue";
import accommodationVue from "./accommodation.vue";
import carryPeopleVue from "./carryPeople.vue";
import transportationVue from "./transportation.vue";
import transferTicketVue from "./transferTicket.vue";
import { getToken } from "@/utils/auth";
import meetingCategoryApi from "@/api/meeting/meetingCategory";
import sysDataconstantApi from "@/api/config/sysDataconstant";
import customerApi from "@/api/technical/customer";
import meetingApi from "@/api/meeting/meeting";
import userApi from "@/api/sys/user";
import technicianInfoApi from "@/api/technical/technicianInfo";
export default {
  components: {
    Pagination,
    recordAdd,
    operaVue,
    accommodationVue,
    carryPeopleVue,
    transportationVue,
    transferTicketVue
  },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload", // 上传的图片服务器地址
      headers: {
        Authorization: "DU " + getToken()
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // 订单编号
        signUpNo: undefined,
        // 参会人相关字段
        keywordsCarryPeople: undefined,
        // 报名人相关字段
        registrantIdentityId: undefined,
        userId: undefined,
        userInfoId: undefined,
        userType: undefined,
        userMobile: undefined,
        meetingTitle: undefined,
        meetingId: undefined,
        meetingType: undefined,
        signInMethod: undefined,
        source: undefined,
        isAssignStay: undefined,
        paymentMethod: undefined
      },
      timeFilter: "",
      dateTime: [],
      selectItems: [],
      activeName: "10",
      meetingCategoryOptions: [],
      fileList: [],
      // 取消报名相关
      cancelRegistrationVisible: false,
      cancelForm: {
        cancelReason: null
      },
      cancelFormRules: {
        cancelReason: [
          { required: true, message: "请选择取消原因", trigger: "change" }
        ]
      },
      cancelReasonOptions: [],
      currentCancelRow: null,
      // 报名人远程搜索相关
      registrantSearchLoading: false,
      registrantSearchOptions: [],
      registrantSearchVal: "",
      selectedRegistrantUser: null,
      // 身份列表
      identityList: [],
      allIdentityList: [],
      // 会议搜索相关
      meetingSearchLoading: false,
      meetingSearchOptions: [],
      meetingSearchVal: "",
      selectedMeetingId: null,
      // 设备签到 / 信息同步弹窗
      signInDialogVisible: false,
      infoSyncDialogVisible: false,
      carryPeopleList: [],
      // 同步报名信息至DXIOT弹窗
      syncToDXIOTDialogVisible: false,
      syncToDXIOTMeetingId: null,
      syncToDXIOTMeetingOptions: [],
      syncToDXIOTLoading: false
    };
  },
  created() {
    this.loadIdentityList();
    this.doQueryList({ pageNo: 1 });
    meetingCategoryApi
      .fetchList({ pageNo: 1, pageSize: 100, isEnable: true })
      .then(({ data }) => {
        this.meetingCategoryOptions = data.list;
      });
  },
  methods: {
    // 加载身份列表
    loadIdentityList() {
      try {
        const levelList = JSON.parse(localStorage.getItem("levelList")) || [];
        this.allIdentityList = levelList.map(level => ({
          id: level.id,
          name: level.name,
          level: level.level,
          userType: 20 //业务线
        }));

        // 添加技术老师
        this.allIdentityList.push({
          id: 99,
          name: "技术老师",
          level: 99,
          userType: 30
        });

        // 添加内部员工
        this.allIdentityList.push({
          id: 101,
          name: "内部员工",
          level: 101,
          userType: 10
        });

        // 初始显示所有身份
        this.identityList = [...this.allIdentityList];
      } catch (error) {
        console.error("加载身份列表失败:", error);
        this.allIdentityList = [];
        this.identityList = [];
      }
    },
    handleFilter() {
      this.query = {};
      this.timeFilter = "";
      this.dateTime = [];
      this.selectedRegistrantUser = null;
      this.registrantSearchOptions = [];
      this.registrantSearchVal = "";
      this.selectedMeetingId = null;
      this.meetingSearchOptions = [];
      this.meetingSearchVal = "";
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign",
        operatedTime: "operatedTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    resetTime() {
      this.query.meetingStartTime = undefined;
      this.query.meetingEndTime = undefined;
      this.query.createdTimeStart = undefined;
      this.query.createdTimeEnd = undefined;
      this.query.signInTimeStart = undefined;
      this.query.signInTimeEnd = undefined;
      this.query.cancelTimeStart = undefined;
      this.query.cancelTimeEnd = undefined;
      this.query.revokeTimeStart = undefined;
      this.query.revokeTimeEnd = undefined;
    },
    calcQuery() {
      if (this.activeName === "22") {
        // this.query.meetingStatus = undefined;
        this.query.status = 90;
      } else {
        // this.query.meetingStatus = this.activeName === "99" ? 10 : undefined;
        this.query.status = this.activeName === "99" ? 20 : +this.activeName;
      }
      // 待审核状态时添加 payVouchersStatus 参数
      if (this.activeName === "10") {
        this.query.payVouchersStatus = 10;
      } else {
        // 其他状态时清除 payVouchersStatus 参数
        this.query.payVouchersStatus = undefined;
      }
      this.resetTime();
      if (this.dataTime && this.dataTime.length > 0) {
        if (this.timeFilter === 1) {
          this.query.meetingStartTime = this.dateTime[0];
          this.query.meetingEndTime = this.dateTime[0];
        } else if (this.timeFilter === 2) {
          this.query.createdTimeStart = this.dateTime[0];
          this.query.createdTimeEnd = this.dateTime[0];
        } else if (this.timeFilter === 3) {
          this.query.signInTimeStart = this.dateTime[0];
          this.query.signInTimeEnd = this.dateTime[0];
        } else if (this.timeFilter === 4) {
          this.query.cancelTimeStart = this.dateTime[0];
          this.query.cancelTimeEnd = this.dateTime[0];
        } else if (this.timeFilter === 5) {
          this.query.revokeTimeStart = this.dateTime[0];
          this.query.revokeTimeEnd = this.dateTime[0];
        }
      }
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      this.calcQuery();

      // 处理支付方式：线上支付需要传数组 [1, 2, 3, 10, 20]，线下支付传 [30]
      const queryParams = { ...this.query };
      if (queryParams.paymentMethod === "online") {
        // 线上支付：余额支付(1)、零售价支付(2)、赠额支付(3)、微信支付(10)、支付宝(20)
        // 使用逗号分隔的字符串格式，后端会解析为数组
        queryParams.paymentMethods = "1,2,3,10,20";
        queryParams.paymentMethod = undefined;
      } else if (queryParams.paymentMethod === "offline") {
        // 线下支付：30
        queryParams.paymentMethods = "30";
        queryParams.paymentMethod = undefined;
      } else {
        // 全部或不选择，不传 paymentMethods 或传 undefined
        queryParams.paymentMethods = undefined;
        queryParams.paymentMethod = undefined;
      }

      this.listLoading = true;
      return meetingSignUpApi
        .fetchList(queryParams)
        .then(data => {
          this.list = data.data.list;
          this.total = data.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //签到
    handleSignin(row) {
      this.$common
        .confirm("请确认客户是否到了现场，再确认签到。")
        .then(() => meetingSignUpApi.meetingSignIn({ id: row.id }))
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    handleCancel(row) {
      this.currentCancelRow = row;
      this.cancelForm.cancelReason = null;
      // 获取取消原因列表
      sysDataconstantApi
        .fetchBatchCode({ code: "meetingCancelReasons" })
        .then(data => {
          const { list } = data.data;
          const find = list.find(itt => itt.code === "meetingCancelReasons");
          if (find) {
            this.cancelReasonOptions = find.content.split(",");
          }
          this.cancelRegistrationVisible = true;
          this.$nextTick(() => {
            if (this.$refs.cancelForm) {
              this.$refs.cancelForm.clearValidate();
            }
          });
        })
        .catch(() => {
          this.$message.error("获取取消原因列表失败");
        });
    },
    // 确认取消报名
    handleConfirmCancel() {
      this.$refs.cancelForm.validate(valid => {
        if (valid) {
          const params = {
            signUpNo: this.currentCancelRow.signUpNo,
            cancelReason: this.cancelForm.cancelReason || null
            // carryPeopleIdCard: this.cancelForm.carryPeopleIdCard || null,
            // refundMethod: this.cancelForm.refundMethod || null
          };
          meetingSignUpApi
            .cancelMeeting(params)
            .then(() => {
              this.$message.success("操作成功");
              this.cancelRegistrationVisible = false;
              this.doQueryList({ pageNo: 1 });
            })
            .catch(res => {
              this.$message.error(res.msg || "操作失败");
            });
        }
      });
    },
    handleDownload() {
      this.$router.push("/export/list?code=EEForMeetSignUp");
    },
    handleImport() {
      this.$router.push("/import/list?code=IEForMeetSignUp");
    },
    handleDownload1() {
      meetingSignUpApi.downloadExcelTemplate();
    },
    handleDownload2() {
      meetingSignUpCarryPeopleApi.downloadExcelTemplateForStay();
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.recordAdd.handleCreate(row);
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit("handleShow", row, type, this.activeName);
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.accommodationVue.handleUpdate(row);
    },
    handleTransportation(row) {
      this.$refs.transportationVue.handleUpdate(row);
    },
    handleMoreCommand(command) {
      const { action, row } = command;
      if (action === "log") {
        this.handleLogRecord(row);
      } else if (action === "transfer") {
        this.handleTransferTicket(row);
      }
    },
    handleLogRecord(row) {
      // TODO: 实现日志记录功能
      this.$message.info("日志记录功能待实现");
    },
    handleTransferTicket(row) {
      this.$refs.transferTicketVue.handleUpdate(row);
    },
    handleCarryPeople(row) {
      this.$refs.carryPeopleVue.handleCarryPeople(row);
    },
    /** 打开设备签到弹窗，请求 teev2 携带人员列表 */
    openSignInDialog(row) {
      if (!row.signUpNo) {
        this.$message.warning("无报名编号");
        return;
      }
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({ signNo: row.signUpNo })
        .then(res => {
          const data = res.data;
          this.carryPeopleList = Array.isArray(data) ? data : (data && data.list) ? data.list : [];
          this.signInDialogVisible = true;
        })
        .catch(() => {
          this.carryPeopleList = [];
          this.$message.error("获取携带人员列表失败");
        });
    },
    /** 打开信息同步弹窗，请求 teev2 携带人员列表 */
    openInfoSyncDialog(row) {
      if (!row.signUpNo) {
        this.$message.warning("无报名编号");
        return;
      }
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({ signNo: row.signUpNo })
        .then(res => {
          const data = res.data;
          this.carryPeopleList = Array.isArray(data) ? data : (data && data.list) ? data.list : [];
          this.infoSyncDialogVisible = true;
        })
        .catch(() => {
          this.carryPeopleList = [];
          this.$message.error("获取携带人员列表失败");
        });
    },
    /** 打开同步报名信息至DXIOT弹窗 */
    openSyncToDXIOTDialog() {
      this.syncToDXIOTMeetingId = null;
      this.syncToDXIOTMeetingOptions = [];
      this.syncToDXIOTDialogVisible = true;
    },
    /** 加载同步DXIOT弹窗的会议列表（与 add 一致：status=10, statusSub=11） */
    loadSyncToDXIOTMeetingOptions() {
      meetingApi
        .fetchList({ pageSize: 100 })
        .then(({ data }) => {
          this.syncToDXIOTMeetingOptions = data.list || [];
        })
        .catch(() => {
          this.syncToDXIOTMeetingOptions = [];
        });
    },
    /** 确认同步报名信息至DXIOT */
    confirmSyncToDXIOT() {
      if (!this.syncToDXIOTMeetingId) {
        this.$message.warning("请选择会议");
        return;
      }
      this.syncToDXIOTLoading = true;
      meetingSignUpApi
        .syncToDXIOT(this.syncToDXIOTMeetingId)
        .then(() => {
          this.$message.success("同步成功");
          this.syncToDXIOTDialogVisible = false;
          this.doQueryList({});
        })
        .catch()
        .finally(() => {
          this.syncToDXIOTLoading = false;
        });
    },
    handleQrcode(row) { },
    uploadFileStay(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      meetingSignUpCarryPeopleApi.importForStay(formData).then(res => {
        if (res.code === "0") {
          this.$message.success(res.msg || "操作成功");
          this.doQueryList({});
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 搜索报名人（远程搜索）
    searchRegistrants(query) {
      if (query !== "") {
        this.registrantSearchLoading = true;
        this.registrantSearchVal = query;
        this.getRegistrantCustomer();
      } else {
        // 如果搜索为空，清空选项
        this.registrantSearchVal = "";
        this.registrantSearchOptions = [];
        this.registrantSearchLoading = false;
      }
    },
    // 加载身份列表
    loadIdentityList() {
      try {
        const levelList = JSON.parse(localStorage.getItem("levelList")) || [];
        this.allIdentityList = levelList.map(level => ({
          id: level.id,
          name: level.name,
          level: level.level,
          userType: 20, // 业务线
          customerTypes: level.customerTypes // 保留 customerTypes 字段
        }));

        // 添加技术老师
        this.allIdentityList.push({
          id: 99,
          name: "技术老师",
          level: 99,
          userType: 30
        });

        // 添加内部员工
        this.allIdentityList.push({
          id: 101,
          name: "内部员工",
          level: 101,
          userType: 10
        });

        // 初始显示所有身份
        this.identityList = [...this.allIdentityList];
      } catch (error) {
        console.error("加载身份列表失败:", error);
        this.identityList = [];
      }
    },
    // 处理报名人身份变化
    handleRegistrantIdentityChange() {
      // 清空报名人选择
      this.selectedRegistrantUser = null;
      this.registrantSearchOptions = [];
      this.registrantSearchVal = "";
      this.query.userId = undefined;
      this.query.userInfoId = undefined;
      this.query.userType = undefined;
    },
    // 获取报名人客户列表（根据身份类型调用不同接口）
    getRegistrantCustomer() {
      if (!this.query.registrantIdentityId) {
        this.registrantSearchLoading = false;
        return;
      }

      // 根据身份判断对应的用户类型
      const identity = this.identityList.find(
        item => item.level === this.query.registrantIdentityId
      );
      if (!identity) {
        this.registrantSearchLoading = false;
        return;
      }

      const userType = identity.userType || 20;

      // 根据用户类型调用不同的接口
      if (userType === 10) {
        // 内部员工
        this.getRegistrantUserList();
      } else if (userType === 20) {
        // 客户
        this.getRegistrantCustomerList();
      } else if (userType === 30) {
        // 技术老师
        this.getRegistrantTechnical();
      } else {
        // 默认按客户处理
        this.getRegistrantCustomerList();
      }
    },
    // 获取报名人客户列表（客户类型）
    getRegistrantCustomerList() {
      this.registrantSearchLoading = true;

      // 获取当前选择的身份信息
      const identity = this.identityList.find(
        item => item.level === this.query.registrantIdentityId
      );

      const params = {
        keywords: this.registrantSearchVal || ""
      };

      // 如果身份对象中有 customerTypes，使用身份中的值，否则使用默认值 "2"
      if (identity && (identity.level === 6 || identity.level === 7 || identity.level === 8)) {
        params.customerTypes = "3";
      } else {
        params.customerTypes = "2"; // 默认值
      }

      // 如果选择了身份，添加 CLevel 参数
      if (this.query.registrantIdentityId) {
        params.CLevel = this.query.registrantIdentityId;
      }
      customerApi
        .listForMini(params)
        .then(({ data }) => {
          const arr = [];
          // 复用之前获取的身份信息
          const identityName = identity ? identity.name : "";
          const userType = identity ? identity.userType : 20;

          data.forEach(it => {
            // 过滤掉姓名为 null 或空字符串的项
            if (!it.name || it.name === "null" || it.name.trim() === "") {
              return;
            }
            const phone = it.pho || "";
            const displayValue = `${it.name}${identityName ? `(${identityName})` : ""
              }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              userId: it.userId,
              userInfoId: it.id, // 用户资料ID
              userType: userType, // 根据身份确定用户类型
              phone: it.pho
            });
          });
          this.registrantSearchOptions = arr;
        })
        .finally(() => {
          this.registrantSearchLoading = false;
        });
    },
    // 获取报名人用户列表（内部员工）
    getRegistrantUserList() {
      this.registrantSearchLoading = true;
      userApi
        .fetchListForMini({
          pageNo: 1,
          pageSize: 100,
          isInternal: 1,
          jobStatus: 1,
          keyword: this.registrantSearchVal || ""
        })
        .then(({ data }) => {
          const arr = [];
          const identity = this.identityList.find(
            item => item.level === this.query.registrantIdentityId
          );
          const identityName = identity ? identity.name : "";

          // 处理分页数据
          const userList = data && data.list ? data.list : (data || []);
          userList.forEach(it => {
            const phone = it.userPho || "";
            const displayValue = `${it.realName || it.userName}${identityName ? `(${identityName})` : ""
              }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              userId: it.id,
              userInfoId: it.id,
              userType: 10, // 内部员工
              phone: it.userPho
            });
          });
          this.registrantSearchOptions = arr;
        })
        .finally(() => {
          this.registrantSearchLoading = false;
        });
    },
    // 获取报名人技术老师列表
    getRegistrantTechnical() {
      this.registrantSearchLoading = true;
      technicianInfoApi
        .listForMini({ status: 10, keywords: this.registrantSearchVal || "" })
        .then(({ data }) => {
          const arr = [];
          const identity = this.identityList.find(
            item => item.level === this.query.registrantIdentityId
          );
          const identityName = identity ? identity.name : "";

          data.forEach(it => {
            // 过滤掉姓名为 null 或空字符串的项
            if (
              !it.realName ||
              it.realName === "null" ||
              it.realName.trim() === ""
            ) {
              return;
            }
            const phone = it.mobile || "";
            const displayValue = `${it.realName}${identityName ? `(${identityName})` : ""
              }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              userId: it.userId,
              userInfoId: it.id,
              userType: 30, // 技术老师
              phone: it.mobile
            });
          });
          this.registrantSearchOptions = arr;
        })
        .finally(() => {
          this.registrantSearchLoading = false;
        });
    },
    // 处理报名人选择变化
    handleRegistrantChange(user) {
      if (user) {
        this.query.userId = user.userId;
        this.query.userInfoId = user.userInfoId;
        this.query.userType = user.userType;
      } else {
        // 清空时重置所有字段
        this.query.userId = undefined;
        this.query.userInfoId = undefined;
        this.query.userType = undefined;
      }
    },
    /**
     * 搜索会议（远程搜索）
     */
    searchMeetings(query) {
      if (query !== "") {
        this.meetingSearchLoading = true;
        this.meetingSearchVal = query;
        this.getMeetingList();
      } else {
        // 如果搜索为空，清空选项
        this.meetingSearchVal = "";
        this.meetingSearchOptions = [];
        this.meetingSearchLoading = false;
      }
    },
    /**
     * 获取会议列表
     */
    getMeetingList() {
      this.meetingSearchLoading = true;
      const params = {
        title: this.meetingSearchVal || "",
        pageNo: 1,
        pageSize: 100
      };
      meetingApi
        .fetchList(params)
        .then(({ data }) => {
          if (data && data.list) {
            this.meetingSearchOptions = data.list || [];
          } else {
            this.meetingSearchOptions = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取会议列表失败");
          this.meetingSearchOptions = [];
        })
        .finally(() => {
          this.meetingSearchLoading = false;
        });
    },
    /**
     * 处理会议选择变化
     */
    handleMeetingChange(meetingId) {
      if (meetingId) {
        // 根据ID找到对应的会议对象
        const meeting = this.meetingSearchOptions.find(item => item.id === meetingId);
        if (meeting) {
          this.query.meetingId = meeting.id;
          this.query.meetingTitle = meeting.title;
        } else {
          this.query.meetingId = meetingId;
        }
      } else {
        // 清空时重置所有字段
        this.query.meetingId = undefined;
        this.query.meetingTitle = undefined;
      }
    },
    /**
     * 获取要显示的参会人信息
     * 优先展示"本人"，如果没有本人则随机展示一个
     */
    getDisplayParticipant(row) {
      // 如果没有 userInfoId，返回 null（会显示"暂未进入app"）
      if (!row.userInfoId) {
        return null;
      }

      // 如果 carryPeoples 数组为空或不存在，使用原有的 userRealName 逻辑
      if (!row.carryPeoples || !Array.isArray(row.carryPeoples) || row.carryPeoples.length === 0) {
        if (row.userRealName) {
          return {
            realName: row.userRealName,
            relationship: null,
            mobile: row.userMobile
          };
        }
        return null;
      }

      // 优先查找"本人"
      const selfParticipant = row.carryPeoples.find(p => p.relationship === "本人");
      if (selfParticipant) {
        return {
          realName: selfParticipant.realName,
          relationship: selfParticipant.relationship,
          mobile: selfParticipant.mobile
        };
      }

      // 如果没有本人，随机展示一个（取第一个）
      if (row.carryPeoples.length > 0) {
        const participant = row.carryPeoples[0];
        return {
          realName: participant.realName,
          relationship: participant.relationship,
          mobile: participant.mobile
        };
      }

      return null;
    },
    /**
     * 格式化费用显示
     */
    formatFee(value) {
      if (value === null || value === undefined || value === '' || value === 0) {
        return '0.00';
      }
      const numValue = Number(value);
      if (isNaN(numValue)) {
        return '0.00';
      }
      return numValue.toFixed(2);
    },
    signUpFeePayMethod(row) {
      if(row.isItCarry){
        return '-';
      }
      if (row.fee === 0) {
        return '免费';
      } else if (row.paymentMethod === 10) {
        return '微信支付';
      } else if (row.paymentMethod === 20) {
        return '支付宝支付';
      } else if (row.paymentMethod === 30) {
        return '线下支付';
      } else if (row.paymentMethod === 1) {
        return '余额支付';
      } else if (row.paymentMethod === 2) {
        return '零售价支付';
      } else if (row.paymentMethod === 3) {
        return '赠额支付';
      }
      return '';
    },
  }
};
</script>

<style lang="scss" scoped>
.meeting-info-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  .meeting-title {
    color: #000000;
  }

  .meeting-category {
    color: #666666;
  }
}

.sync-status-text {
  font-size: 14px;
  color: #4680e3;
}

.sync-status-click {
  cursor: pointer;
}
</style>
